var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 2.32292C17.0005 2.62177 16.9605 2.91704 16.8828 3.18705C16.805 3.45705 16.6915 3.69493 16.5507 3.8832L9.26565 13.5449C9.04839 13.8392 8.77588 14 8.49465 14C8.21342 14 7.9409 13.8392 7.72365 13.5449L0.438623 3.54314C0.190669 3.2036 0.0347394 2.71569 0.00513828 2.18675C-0.0244629 1.6578 0.0746887 1.13114 0.28078 0.722633C0.486872 0.314126 0.783022 0.0572319 1.10408 0.00846391C1.42514 -0.0403041 1.74481 0.123049 1.99276 0.462586L8.50072 9.4042L15.0087 0.762643C15.1869 0.518033 15.4039 0.36265 15.6341 0.314882C15.8642 0.267114 16.0978 0.328959 16.3073 0.4931C16.5168 0.657242 16.6934 0.916809 16.8161 1.24109C16.9388 1.56537 17.0026 1.94079 16.9999 2.32292Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.0fad4d2e11d01fb1531549114274e120.svg";
export { ForwardRef as ReactComponent };